import Highcharts, { SeriesOptionsType } from "highcharts";
import { DataSample, DataSampleUnit } from "../../types";
import { getUnitString } from "../../utils";
import { toHighchartsXY } from "./windChart";


export const temperatureChart = {
	temperatureSeries: function (title: string | undefined, data: DataSample[], unit: DataSampleUnit): SeriesOptionsType {
		const dataSeries = toHighchartsXY(data) ?? [];
		return {
			type: "spline",
			name: title,
			yAxis: 0,
			tooltip: {
				valueSuffix: getUnitString(unit),
				valueDecimals: 2
			},
			colorIndex: 2,
			dataGrouping: {
				enabled: true,
				groupPixelWidth: 5
			},
			data: dataSeries
		};
	},
	create: function (options: { containerId: string, historyChartIntervalHours: number }, unit: DataSampleUnit) {
		return new Highcharts.Chart({
			chart: {
				renderTo: options.containerId,
				backgroundColor: "transparent"
			},
			credits: {
				enabled: false,
			},
			exporting: {
				enabled: false,
			},
			title: {
				text: `Temperature last ${options.historyChartIntervalHours === 1 ? "hour" : `${options.historyChartIntervalHours} hours`}`,
				x: -20, //center
			},
			xAxis: {
				type: 'datetime',
				gridLineColor: '#666666',
				tickInterval: (options.historyChartIntervalHours * 3600 * 1000) / 10,
				tickWidth: 0,
				gridLineWidth: 1,
				labels: {
					style: {
						color: '#f8f9fa'
					}
				}
			},
			yAxis: [
				{
					gridLineColor: '#666666',
					title: {
						text: '',
						style: {
							color: '#f8f9fa'
						}
					},
					labels: {
						format: '{value} ' + getUnitString(unit),
						style: {
							color: '#f8f9fa'
						}
					},
					plotLines: [
						{
							value: 0,
							width: 1
						},
					],
				}
			],
			tooltip: {
				enabled: true,
				shared: true,
				headerFormat: '<small>{point.x:%d.%m.%Y %H:%M:%S}</small><br>',
			},
			legend: {
				itemStyle: {
					color: '#f8f9fa'
				},
				itemHoverStyle: {
					color: '#666666'
				},
			},
			plotOptions: {
				spline: {
					lineWidth: 2,
					states: {
						hover: {
							lineWidth: 2,
						},
					},
					marker: {
						enabled: false,
					}
				},
			},
			series: [],
		});
	},
};